// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
* Fonts
*/
/**
* Font sizes
*/
/**
* Breakpoints
*/
/**
* Spinner
*/
.Paginator_pagination__uS6JB {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  align-items: center;
  justify-content: center;
  padding: 15px;
}
.Paginator_pagination__item__a3OLF {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  color: #92929D;
  font-size: 14px;
  margin-bottom: 5px;
  cursor: pointer;
  transition: 0.3s ease-in-out;
}
.Paginator_pagination__item__a3OLF:not(:last-child) {
  margin-right: 10px;
}
@media screen and (max-width: 480px) {
  .Paginator_pagination__item__a3OLF:not(:last-child) {
    margin-right: 5px;
  }
}
.Paginator_pagination__item--active__WIGKz, .Paginator_pagination__item__a3OLF:hover, .Paginator_pagination__item__a3OLF:focus {
  color: #05435C;
}
.Paginator_pagination__item--disabled__2WD0p {
  color: #04384e;
  pointer-events: none;
}
.Paginator_pagination__item--disabled__2WD0p:hover, .Paginator_pagination__item--disabled__2WD0p:focus {
  color: #04384e;
}
.Paginator_pagination__arrow__o5npL {
  border: 1px solid #05435C;
  border-radius: 4px;
  color: #05435C;
  font-size: 0;
}
.Paginator_pagination__arrow__o5npL:hover, .Paginator_pagination__arrow__o5npL:focus {
  background-color: #05435C;
  color: #fff;
}
.Paginator_pagination__arrow--next__OQSXg {
  transform: rotate(180deg);
}
.Paginator_pagination__arrow--disabled__7-NyN {
  color: #04384e;
  border: 1px solid #E2E2EA;
  pointer-events: none;
}
.Paginator_pagination__arrow--disabled__7-NyN:hover, .Paginator_pagination__arrow--disabled__7-NyN:focus {
  color: #04384e;
  border: 1px solid #E2E2EA;
}
@media screen and (max-width: 480px) {
  .Paginator_pagination__uS6JB {
    justify-content: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/base/_variables.scss","webpack://./src/components/UI/Paginator/Paginator.module.scss"],"names":[],"mappings":"AAAA;;CAAA;AAeA;;CAAA;AAWA;;CAAA;AAUA;;CAAA;AClCA;EACE,aAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AAWF;AATE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,eDGc;ECFd,kBAAA;EACA,eAAA;EACA,4BAAA;AAWJ;AATI;EACE,kBAAA;AAWN;AATM;EAHF;IAII,iBAAA;EAYN;AACF;AATI;EAGE,cAAA;AASN;AANI;EACE,cAAA;EACA,oBAAA;AAQN;AANM;EAEE,cAAA;AAOR;AAFE;EACE,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;AAIJ;AAFI;EAEE,yBAAA;EACA,WAAA;AAGN;AAAI;EACE,yBAAA;AAEN;AACI;EACE,cAAA;EACA,yBAAA;EACA,oBAAA;AACN;AACM;EAEE,cAAA;EACA,yBAAA;AAAR;AAKE;EA1EF;IA2EI,uBAAA;EAFF;AACF","sourcesContent":["/**\n* Fonts\n*/\n$font-path: \"../../fonts/\";\n$font-family-default: \"Arial\", \"Helvetica\", sans-serif;\n$font-family-custom: \"Circe\";\n$font-family-global: $font-family-custom, sans-serif;\n\n$font-family: $font-family-custom, $font-family-default;\n$font-weight-thin: 100;\n$font-weight-light: 300;\n$font-weight-regular: 400;\n$font-weight-bold: 700;\n$font-weight-extra-bold: 800;\n\n/**\n* Font sizes\n*/\n$font-size-super-tiny: 10px;\n$font-size-tiny: 12px;\n$font-size-small: 14px;\n$font-size-normal: 16px;\n$font-size-medium: 18px;\n$font-size-big: 32px;\n$font-size-large: 36px;\n\n/**\n* Breakpoints\n*/\n$screen-mobile-extra-mini: '(max-width: 375px)';\n$screen-mobile-mini: '(max-width: 480px)';\n$screen-mobile: '(max-width: 767px)';\n$screen-tablet: '(max-width: 991px)';\n$screen-tablet-horizontal: '(max-width: 1133px)';\n$screen-desktop: '(max-width: 1340px)';\n\n/**\n* Spinner\n*/\n$spin-color: var(--color-primary);","@import \"../../../styles/base/variables\";\n\n.pagination {\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  padding: 15px;\n\n  &__item {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 32px;\n    height: 32px;\n    color: #92929D;\n    font-size: $font-size-small;\n    margin-bottom: 5px;\n    cursor: pointer;\n    transition: 0.3s ease-in-out;\n\n    &:not(:last-child) {\n      margin-right: 10px;\n\n      @media screen and #{$screen-mobile-mini} {\n        margin-right: 5px;\n      }\n    }\n\n    &--active,\n    &:hover,\n    &:focus {\n      color: #05435C;\n    }\n\n    &--disabled {\n      color: #04384e;\n      pointer-events: none;\n\n      &:hover,\n      &:focus {\n        color: #04384e;\n      }\n    }\n  }\n\n  &__arrow {\n    border: 1px solid #05435C;\n    border-radius: 4px;\n    color: #05435C;\n    font-size: 0;\n\n    &:hover,\n    &:focus {\n      background-color: #05435C;\n      color: #fff;\n    }\n\n    &--next {\n      transform: rotate(180deg);\n    }\n\n    &--disabled {\n      color: #04384e;\n      border: 1px solid #E2E2EA;\n      pointer-events: none;\n\n      &:hover,\n      &:focus {\n        color: #04384e;\n        border: 1px solid #E2E2EA;\n      }\n    }\n  }\n\n  @media screen and #{$screen-mobile-mini} {\n    justify-content: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pagination": `Paginator_pagination__uS6JB`,
	"pagination__item": `Paginator_pagination__item__a3OLF`,
	"pagination__item--active": `Paginator_pagination__item--active__WIGKz`,
	"pagination__item--disabled": `Paginator_pagination__item--disabled__2WD0p`,
	"pagination__arrow": `Paginator_pagination__arrow__o5npL`,
	"pagination__arrow--next": `Paginator_pagination__arrow--next__OQSXg`,
	"pagination__arrow--disabled": `Paginator_pagination__arrow--disabled__7-NyN`
};
export default ___CSS_LOADER_EXPORT___;
